/* eslint-disable react/no-multi-comp */
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Dialog, { DialogTitle } from 'material-ui/Dialog';
import Typography from 'material-ui/Typography';
import { Button, DialogActions, DialogContent, FormControlLabel, Grid, Paper, Radio } from 'material-ui';
import InformationPopOver from '../../../ui/InformationPopOver';
import InfoIcon from 'material-ui-icons/Info';
import RoomIcon from 'material-ui-icons/Hotel';
import { getUserInformation } from '../../Login/loginService';
import currencyFormatter from 'currency-formatter';
import { translate } from 'react-i18next';
import classNames from 'classnames';


import ResultCardPrice from '../../Results/ResultCardPrice';
import { netPrice } from '../../../defaultValues/netPrice';
import getValue from '../../../defaultValues/getValue';

const styles = theme => ({
    avatar: {
        backgroundColor: 'dark-grey',
        color: 'grey',
    },
    inputLabel: {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
    },
    roomNumberTextField: {
        width: '140px',
        marginBottom: '32px',
    },
    footNoteText: {
        marginTop: '16px',
        fontWeight: 300,
        paddingTop: 0
    },
    dialogTitle: {
        fontWeight: '300',
        fontSize: '16px',
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main
    },
    bedIcon: {
        color: theme.palette.primary.main,
        backgroundColor: theme.palette.background.main,
        opacity: '0.9'
    },
    roomPos: {
        color: theme.palette.primary.main,
    },
    availability: {
        color: theme.palette.primary.main,
    },
    price: {
        marginTop: '0px',
        marginBottom: '4px',
        fontWeight: 700,
        fontSize: '1.5em',
        color: theme.palette.secondary.main,
        textAlign: 'right'
    },
    pvp: {
        color: theme.palette.primary.contrastText,
        background: '#000000', // No lo llevo al Theme porque es el único lugar donde se usa.
    },
    mealPlan: {
        color: theme.palette.primary.contrastText,
        background: '#6495ed',
        padding: '4px'
    }
});

/**
 * Componente encargado de la edicion de huespedes y habitaciones.
 * Maneja una copia del rooms original. Si cancela no devuelve el rooms, Si Acepta devuelve el rooms actualizado.
 *
 * @author Luciano Bustos
 *
 */
class ReservationAvailabilityDialog extends React.Component {
    constructor(props) {
        super(props);

        this.currentUser = getUserInformation();
        this.state = { 'selectedRooms': {} };
    }

    priceTagRender = (price, retailPrice, B2bVerPVP) => {
        return B2bVerPVP ?
            (<Typography className={this.props.classes.price}>{
                retailPrice ?
                    <span title={this.props.t('BOOKINGS.NET') + ': ' + this.formatPrice(price)}>
                        {this.formatPrice(retailPrice)}
                    </span> : ''
            }
            </Typography>)
            :
            (<Typography className={this.props.classes.price}>
                {this.formatPrice(price)}
            </Typography>);
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps && nextProps.rooms) {
            let state = this.state;
            state.rooms = nextProps.rooms;
            this.setState(state);
        }
        if (nextProps && nextProps.totalRooms) {
            let state = this.state;
            state.totalRooms = nextProps.totalRooms;
            this.setState(state);
        }
    }

    handleClose = () => {
        let rooms = Object.keys(this.state.selectedRooms).map(
            key => this.state.selectedRooms[key]);
        this.props.onClose(rooms);
    };

    handleCancel = () => {
        this.props.onClose(null);
    };

    formatPrice = (value) => {
        return currencyFormatter.format(value, { code: 'EUR' });
    };

    handleOptionChange = (room, opt) => {
        const selectedRoom = {
            order: room.order,
            adults: room.adults,
            kids: room.kids,
            option: opt,
        };

        this.setState((prevState, props) => {
            const roomOrder = room.order;
            let selectedRooms = Object.assign({}, prevState.selectedRooms);
            selectedRooms[roomOrder] = selectedRoom;
            return {
                selectedRooms: selectedRooms,
            };
        });
    };

    isOptionChecked = (room, opt) => {
        const selectedRoom = this.state.selectedRooms[room.order];
        return !!(selectedRoom && selectedRoom.option.serviceCode === opt.serviceCode);
    };

    notAllRoomsAreSelected = (rooms) => Object.keys(this.state.selectedRooms).length !== rooms.length;

    labelAvailability = value => {
        const labels = {
            OK: this.props.t('BOOKINGS.STATE_OK'),
            RQ: this.props.t('BOOKINGS.STATE_ON_REQUEST_2'),
            SS: this.props.t('BOOKINGS.STATE_STOP_SALES'),
        };
        if (value === 'RQ') {
            return (
                <span className={this.props.classes.availability} style={{ fontWeight: 500 }}>
                    {labels[value]}
                </span>
            );
        }
        return labels[value];
    };

    renderOffers = (offers) =>
        offers.map(o => (
            <div>
                {' '}
                {o.type} <br />{' '}
            </div>
        ));

    renderDialogTitle = (checkIn, checkOut) => {
        return this.props.t('MODIFY_BOOKING.AVAILABILITY_DIALOG_TITLE', { checkin: checkIn, checkout: checkOut });
    };

    render() {
        const { classes, data, modifiedReservation, t, ...other } = this.props;
        const B2bVerPVP = this.currentUser.authorities.includes('B2bVerPVP');
        let rooms = data && data.hotels[0] && data.hotels[0].rooms ? data.hotels[0].rooms : [];

        const checkIn = modifiedReservation ? modifiedReservation.checkIn : '';
        const checkOut = modifiedReservation ? modifiedReservation.checkOut : '';

        return (
            <Dialog
                onClose={this.handleClose}
                onEnter={this.handleEnter}
                aria-labelledby="reservation-availability-dialog"
                fullWidth={true}
                maxWidth="md"
                {...other}
            >
                <DialogTitle disableTypography={true} id="reservation-availability-dialog" className={classes.dialogTitle}>
                    {this.renderDialogTitle(checkIn, checkOut)}
                </DialogTitle>
                <DialogContent>
                    <Paper className="cmsPopupModification"style={{ minWidth: '640px', padding: '12px' }} elevation={0}>
                        {rooms.length ?
                            rooms.map((room, idx) => {
                                return (
                                    <div key={idx} style={{ paddingTop: (idx > 0) ? '20px' : '0px' }}>
                                        <div style={{ paddingTop: (idx > 0) ? '14px' : '0px', marginRight: '10px', float: 'left' }}>
                                            <RoomIcon style={{backgroundColor:'white'}} className={classes.bedIcon} />
                                        </div>
                                        <Typography style={{
                                            fontWeight: '700',
                                            fontSize: '14px',
                                            height: '33px',
                                            paddingTop: (idx > 0) ? '17px' : '4px'
                                        }}>
                                            <span className={classes.roomPos}>
                                                {t('RESULT_CARD.ROOM_POS', { pos: idx + 1 })}
                                            </span>
                                            <div style={{ marginTop: '5px', borderBottom: '1px solid #e5e5e5' }} />
                                        </Typography>
                                        <table width="100%">
                                            {room.options.map((opt, idx2) => {
                                                return (
                                                    <tr
                                                        style={{
                                                            paddingLeft: '10px',
                                                            paddingRight: '10px',
                                                            height: '66px',
                                                            backgroundColor: this.isOptionChecked(room, opt)
                                                                ? '#e5e5e5'
                                                                : 'white',
                                                        }}>
                                                        {/*
                                                        RADIOBUTTON / ROOM TYPE
                                                    */}
                                                        <td>
                                                            <FormControlLabel
                                                                control={
                                                                    <Radio
                                                                        onChange={() =>
                                                                            this.handleOptionChange(room, opt)
                                                                        }
                                                                        checked={this.isOptionChecked(room, opt)}
                                                                        value={opt.serviceCode}
                                                                        name="radio-button-demo"
                                                                        aria-label="A"
                                                                    />
                                                                }
                                                                label={opt.service}
                                                            />
                                                        </td>

                                                        {/*
                                                        MEALPLAN
                                                    */}
                                                        <td>
                                                            <div className={classNames(classes.mealPlan)}>
                                                                <small>{opt.description}</small>
                                                            </div>
                                                        </td>
                                                        {/*
                                                        REFUNDABLE
                                                    */}
                                                        <td>
                                                            <InformationPopOver
                                                                label={opt.refundable ? '' : t('MODIFY_BOOKING.NO_REFUNDABLE')}
                                                                icon={
                                                                    <InfoIcon
                                                                        style={{
                                                                            color: 'white',
                                                                        }}
                                                                    />
                                                                }>
                                                                <small>
                                                                    <b>
                                                                        {opt.refundable
                                                                            ? ''
                                                                            : t('MODIFY_BOOKING.NO_REFUNDABLE')}
                                                                    </b>
                                                                </small>
                                                            </InformationPopOver>
                                                        </td>

                                                        {/*
                                                        AVAILABLE
                                                    */}
                                                        <td>
                                                            {this.labelAvailability(opt.available)}
                                                        </td>

                                                        {/*
                                                        OFFER AND RESTRICTIONS
                                                    */}
                                                        <td>
                                                            {opt.offer !== null && opt.offer.length > 0 ? (
                                                                <InformationPopOver
                                                                    label={t('MODIFY_BOOKING.OFFER')}
                                                                    className="Offer"
                                                                    icon={
                                                                        <InfoIcon
                                                                            style={{
                                                                                color: 'white',
                                                                            }}
                                                                        />
                                                                    }>
                                                                    <small>{this.renderOffers(opt.offer)}</small>
                                                                </InformationPopOver>
                                                            ) : (
                                                                <InformationPopOver
                                                                    label={t('MODIFY_BOOKING.OFFER')}
                                                                    className="HiddenOffer"
                                                                    icon={
                                                                        <InfoIcon
                                                                            style={{
                                                                                color: 'white',
                                                                            }}
                                                                        />
                                                                    }>
                                                                    <small>{this.renderOffers(opt.offer)}</small>
                                                                </InformationPopOver>
                                                            )}
                                                            {opt.restrictions ? (
                                                                <InformationPopOver
                                                                    label={t('MODIFY_BOOKING.RESTRICTIONS')}
                                                                    className="Restrictions"
                                                                    icon={
                                                                        <InfoIcon
                                                                            style={{
                                                                                color: 'white',
                                                                            }}
                                                                        />
                                                                    }>
                                                                    <small>
                                                                        <b>{t('MODIFY_BOOKING.RESTRICTIONS') + ':'}</b>
                                                                    </small>
                                                                    <br />
                                                                    <small>
                                                                        {opt.restrictions.reduce((all, res) => {
                                                                            return all + res.name;
                                                                        }, '')}
                                                                    </small>
                                                                </InformationPopOver>
                                                            ) : (
                                                                ''
                                                            )}
                                                        </td>

                                                        {/*
                                                        PRICE
                                                    */}
                                                        <td>
                                                            <ResultCardPrice
                                                                price={opt.price}
                                                                pvp={opt.retailPrice}
                                                                B2bVerPVP={B2bVerPVP}
                                                                showPvpIcon={B2bVerPVP && getValue(netPrice, this.currentUser.accountName.toLowerCase())}
                                                            />
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </table>
                                        <div style={{ borderBottom: '1px solid #e5e5e5' }} />
                                    </div>
                                );
                            })
                            :
                            data ? <small><b>{data.emptyMessage}</b> </small> : <small style={{ color: 'red' }}><b>{this.props.error}</b></small>
                        }
                    </Paper>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleCancel}>{t('COMMON.CANCEL')}</Button>
                    <Button onClick={this.handleClose} color="primary" variant="raised"
                        disabled={(this.props.error != undefined || data && data.emptyMessage) || this.notAllRoomsAreSelected(rooms)}>{t('COMMON.SELECT')}</Button>
                </DialogActions>
            </Dialog>
        );
    }
}

ReservationAvailabilityDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    onClose: PropTypes.func,
};

export default translate('translations')(withStyles(styles)(ReservationAvailabilityDialog));



// WEBPACK FOOTER //
// ./src/components/Reservation/Modification/ReservationAvailabilityDialog.js